import { render, staticRenderFns } from "./SpinMaterialButtons.vue?vue&type=template&id=8517744c&scoped=true&"
import script from "./SpinMaterialButtons.vue?vue&type=script&lang=js&"
export * from "./SpinMaterialButtons.vue?vue&type=script&lang=js&"
import style0 from "./SpinMaterialButtons.vue?vue&type=style&index=0&id=8517744c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8517744c",
  null
  
)

export default component.exports